import {
    ArrayField, BooleanField, Datagrid, DateField, NumberField, ReferenceField,
    Show, SimpleShowLayout, TextField, useGetOne, useRecordContext
} from "react-admin";
import { JsonField } from "./JsonField";
import { Button, Divider, Stack } from "@mui/material";
import { useState } from "react";
import { sendEvent } from "@/src/services";




export function TransactionShow() {

    return (
        <Show >
            <Stack>
                <SimpleShowLayout direction={"row"} divider={<Divider orientation="vertical" flexItem />}>
                    <TextField source="id" />
                    <TextField source="refId" />
                    <TextField source="provider" />
                    <WallettoRebillButton />
                </SimpleShowLayout>
                <SimpleShowLayout direction={"row"} divider={<Divider orientation="vertical" flexItem />}>
                    <TextField source="status" />
                    <DateField source="createdAt" />
                    <DateField source="updatedAt" />
                </SimpleShowLayout>
                <SimpleShowLayout>

                    <ReferenceField label="User" source="user" reference="user">
                        <TextField source="profile.nickname" />
                    </ReferenceField>
                </SimpleShowLayout>
                <SimpleShowLayout direction={"row"} divider={<Divider orientation="vertical" flexItem />}>
                    <ReferenceField label="Product" source="product" reference="product">
                        <TextField source="title" />

                    </ReferenceField>
                    <ReferenceField label="Product Type" source="product" reference="product">
                        <TextField source="type" />
                    </ReferenceField>
                    <ReferenceField label="Recurrent" source="product" reference="product" link={false}>
                        <TextField source="autoRenewal" />
                    </ReferenceField>

                </SimpleShowLayout>

                <SimpleShowLayout direction={"row"} divider={<Divider orientation="vertical" flexItem />} >
                    <NumberField source="amount" />
                    <TextField source="currency" />
                </SimpleShowLayout>
                <SimpleShowLayout direction={"row"} divider={<Divider orientation="vertical" flexItem />}>
                    <TextField source="type" />
                    <BooleanField source="isTest" />
                </SimpleShowLayout>
            </Stack>
            <SimpleShowLayout>
                <JsonField source="private" />

                <ArrayField source="dataList">
                    <Datagrid bulkActionButtons={false} >
                        <JsonField />

                    </Datagrid>
                </ArrayField>


            </SimpleShowLayout>
        </Show>
    )
}


const WallettoRebillButton = (props: any) => {
    const record = useRecordContext(props)

    const { data: productData } = useGetOne('product', record?.product, { enabled: !!record })
    const { data: userData } = useGetOne('user', record?.user, { enabled: !!record });

    const [disabled, setDisabled] = useState(false)
    // const user = useGetOne('user', record.user);
    if (record?.provider !== "walletto" || !productData || !userData)
        return null
    if (productData?.type == "subscription" && productData?.autoRenewal && userData.premium?.isActive) {

        return <Button variant="outlined" color="primary" disabled={disabled} onClick={() => {
            setDisabled(true)
            sendEvent("invoke-event", "post", {
                data: {
                    path: '/payment/callback/walletto',
                    body: {
                        command: "rebill",
                        userId: userData.id
                    }
                }
            })
        }}>Rebill</Button>
    } else
        return null
}